import React from 'react'

import Form from 'react-bootstrap/Form'
import Stack from 'react-bootstrap/Stack'

export function ColorField({ id, label, value, onChange }) {
  const colorInputValue = normalizeHexColor(value, '#000000')

  return (
    <Form.Group controlId={id}>
      <Form.Label>{label}</Form.Label>
      <Stack direction="horizontal" gap={3}>
        <Form.Control
          type="color"
          value={colorInputValue}
          onChange={(e) => onChange(e.target.value)}
          title={`Choose ${label.toLowerCase()}`}
        />
        <Form.Control
          type="text"
          aria-label={label}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-16"
        />
      </Stack>
    </Form.Group>
  )
}

export function normalizeHexColor(value, fallback) {
  if (!value) return fallback
  const trimmed = value.trim()
  if (/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return trimmed
  if (/^[0-9A-Fa-f]{6}$/.test(trimmed)) return `#${trimmed}`
  return fallback
}
